import NewTPTaskIcon from "../components/svgs/NewTPTaskIcon";
import NewLikesTaskIcon from "../components/svgs/NewLikesTaskIcon";
import NewComentsTaskIcon from "../components/svgs/NewComentsTaskIcon";
import AddProfilePictureIcon from "../components/svgs/AddProfilePictureIcon";
import AddProfileDetailsIcon from "../components/svgs/AddProfileDetailsIcon";
import AddFavBrandIcon from "../components/svgs/AddFavBrandIcon";
import TPOptimizationIcon from "../components/svgs/TPOptimizationIcon";
import SurveyTaskIcon from "../components/svgs/SurveyTaskIcon";
import QuizTaskIcon from "../components/svgs/QuizTaskIcon";

export const getTaskImage = (template, color) => {
  switch (template) {
    case "newTP":
      return <NewTPTaskIcon color={color} />;
    case "likes":
      return <NewLikesTaskIcon color={color} />;
    case "comments":
      return <NewComentsTaskIcon color={color} />;
    case "profilePicture":
      return <AddProfilePictureIcon color={color} />;
    case "profileDetails":
      return <AddProfileDetailsIcon color={color} />;
    case "improvedTP":
      return <TPOptimizationIcon color={color} />;
    case "realSurveys":
    case "surveys":
      return <SurveyTaskIcon color={color} />;
    case "quizzes":
    case "timeTrial":
      return <QuizTaskIcon color={color} />;
    default:
      return <AddFavBrandIcon color={color} />;
  }
};

export const BOOLEAN_TASK_TEMPLATES = new Set(["profilePicture", "profileDetails", "favoriteBrand"]);
